import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NotificationsService } from '../notifications/notifications.service';
import { FileDownloadService } from './files/file-download.service';
import { FileUploadService } from './files/file-upload.service';
import { LoaderService } from './loader/loader.service';
import { AuthCallbackComponent } from './oidc/auth-callback/auth-callback.component';
import { AuthService } from './oidc/auth.service';
import { LinkCallbackComponent } from './oidc/link-callback/link-callback.component';
import { SettingsService } from './settings/settings.service';
import { TranslatorService } from './translator/translator.service';
import {ThemesServiceV2 } from './themes/themes.service';

@NgModule({
  imports: [CommonModule, HttpClientModule, MatProgressBarModule, MatProgressSpinnerModule],
  providers: [
    AuthService,
    SettingsService,
    TranslatorService,
    NotificationsService,
    LoaderService,
    FileDownloadService,
    FileUploadService,
    ThemesServiceV2
  ],
  exports: [],
  declarations: [AuthCallbackComponent, LinkCallbackComponent]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error(`CoreModule has already been loaded. Import Core modules in the AppModule only.`);
    }
  }
}
